
  var style = require("icon-maker-loader/.tmp/0a2f764c-24f4-42c4-9868-1a0d858032dd/icon-maker.js");
  var mainClass = style["icon-maker"];
  if (mainClass) {
    module.exports = mainClass + " " + style["icon-maker-back"];
  } else {
    module.exports = "icon-maker icon-maker-back";
  }
  


//////////////////
// WEBPACK FOOTER
// ./src/icons/back.svg
// module id = 535
// module chunks = 5